import { z } from 'zod';

import type { PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';
import { transformFormStateToSchema, transformZodErrorToFormState } from 'src/app/pages/petitionEditV2/shared/utils';

import { editFormSchema, serializeParsedPetitionData } from './editFormSchema';

export type ParsedPetitionSchema = z.infer<typeof editFormSchema>;
export type ParsedErrors = ReturnType<typeof transformZodErrorToFormState>;
type SchemaValidReturn =
	| { status: 'success'; data: Partial<ParsedPetitionSchema> & { id: string } }
	| { status: 'error'; error: ParsedErrors };

export function validateSchema(state: PetitionEditPageState): SchemaValidReturn {
	// state -> zod schema
	const values = transformFormStateToSchema(state);
	const parsedData = editFormSchema.safeParse(values);

	if (parsedData.success) {
		return {
			status: 'success',
			data: serializeParsedPetitionData(parsedData.data, state),
		};
	}

	return {
		status: 'error',
		error: transformZodErrorToFormState(z.flattenError(parsedData.error).fieldErrors),
	};
}
